/**
 * Creates a new Care Navigator Form object.
 * @class CareNavigatorForm
 */
class CareNavigatorForm {

  /**
   * Initialize object properties and options.
   */
  constructor(card, radio) {
    /**
     * Initialize the CareNavigatorForm object with all of its object elements.
     * @param {Object} card - The `Care Navigator Cards` block.
     * @param {Object} radio - Radio input item.
     */
    this.card = card;
    this.radio = radio;
  }

  /**
   * Initialize card click listener.
   */
  initRadioCards() {
    /**
     * Binding the class object will not work here due to the fact that `this` is needed inside the callback.
     * So, use the `that | self` var method to allow `this` to keep context.
     */
    let self = this;

    this.card.on('click', function () {
      /* Change radio button `checked` value when card is clicked */
      $( this ).siblings(self.radio).prop('checked', true);
    });
  }

  /**
   * Method callback to initialize the CareNavigatorForm object.
   */
  init() {
    this.initRadioCards();
  }
}

/* Export the class as default. */
export default CareNavigatorForm;
